export const isStandaloneDisplayMode = ({
  matchMedia,
  navigator,
} = {}) => {
  const resolvedNavigator =
    navigator || (typeof window !== "undefined" ? window.navigator : {});
  const resolvedMatchMedia =
    matchMedia || (typeof window !== "undefined" ? window.matchMedia : null);

  return Boolean(
    resolvedNavigator?.standalone ||
      resolvedMatchMedia?.("(display-mode: standalone)")?.matches,
  );
};

export const isPhoneLikeDevice = ({ navigator } = {}) => {
  const resolvedNavigator =
    navigator || (typeof window !== "undefined" ? window.navigator : {});
  const userAgent = resolvedNavigator?.userAgent || "";
  const platform = resolvedNavigator?.userAgentData?.platform || "";
  const maxTouchPoints = Number(resolvedNavigator?.maxTouchPoints || 0);
  const explicitTablet =
    /iPad|Tablet/i.test(userAgent) ||
    /iPad/i.test(platform) ||
    (/Android/i.test(userAgent) && !/Mobile/i.test(userAgent));
  const phoneUserAgent =
    /iPhone|iPod|IEMobile|Opera Mini/i.test(userAgent) ||
    /iPhone|iPod/i.test(platform) ||
    (/Android/i.test(userAgent) && /Mobile/i.test(userAgent));

  return Boolean(maxTouchPoints > 0 && phoneUserAgent && !explicitTablet);
};

export const shouldUseStableMobileLayout = ({
  mediaQueryMatches = false,
  navigator,
} = {}) =>
  Boolean(mediaQueryMatches || isPhoneLikeDevice({ navigator }));

export const lockInstalledPwaToPortrait = async ({
  matchMedia,
  navigator,
  screen,
} = {}) => {
  const resolvedScreen =
    screen || (typeof window !== "undefined" ? window.screen : null);
  if (
    !isStandaloneDisplayMode({ matchMedia, navigator }) ||
    !isPhoneLikeDevice({ navigator })
  ) {
    return false;
  }

  const orientation = resolvedScreen?.orientation;
  if (typeof orientation?.lock !== "function") {
    return false;
  }

  try {
    await orientation.lock("portrait-primary");
    return true;
  } catch (error) {
    return false;
  }
};
